import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const CheckEmail = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "sign-up-check-email" */ './hocs')),
});
